export default __webpack_public_path__ + "static/0181-8e3451b2dc519c1666d248aab7808890.png";